import { CSSProperties, KeyboardEventHandler, MouseEventHandler, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { KeyValue } from '@mews/enums';
import { getToken } from '@optimus-web/common';
import { Card, CardProps } from '@optimus-web/core';

const InteractiveCardWrapper = styled(Card)`
    cursor: pointer;
    &:hover {
        background-color: ${getToken('backgroundInteractiveNeutralSubtleHover')};
    }
`;

const handleKeyDown: KeyboardEventHandler<HTMLElement> = (e) => {
    const key = e.key === ' ' ? KeyValue.Spacebar : (e.key as KeyValue);
    if ([KeyValue.Spacebar, KeyValue.Enter].includes(key)) {
        e.currentTarget.click();
    }
};

interface InteractiveCardProps extends CardProps {
    onClick?: MouseEventHandler<HTMLElement>;
    style?: CSSProperties;
}

export const InteractiveCard = ({ children, ...rest }: PropsWithChildren<InteractiveCardProps>) => (
    <InteractiveCardWrapper padding="200" tabIndex={0} role="button" onKeyDown={handleKeyDown} {...rest}>
        {children}
    </InteractiveCardWrapper>
);
